import { useCallback } from 'react';

const useRemConvert = () => {
	const pxPerRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
	const pxToRem = useCallback((px: number) => px / pxPerRem, [pxPerRem]);
	const remToPx = useCallback((rem: number) => rem * pxPerRem, [pxPerRem]);

	return {
		pxToRem,
		remToPx,
	};
};

export default useRemConvert;
